module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"firmware_modal.title":"Firmware","firmware_modal.title.update":"แก้ไขข้อมูล Firmware","firmware_modal.ok":"เพิ่ม","firmware_modal.ok.update":"@:common.save","firmware.field.name.placeholder":"เลข Version ของ Firmware นี้","firmware.field.remark.placeholder":"หมายเหตุ เช่น แก้ไขปัญหา ...","firmware.field.released_date.help":"วันที่เริ่มใช้งาน Firmware ตัวนี้"}}')
  delete Component.options._Ctor
}
